module.exports = __webpack_public_path__ + "img/rodrigoocana.a905c247.jpeg";